export enum NotificationTargetType {
  MarketplaceOrderTargetType = "MarketplaceOrderTargetType",
  InboundTargetType = "InboundTargetType",
  BulkUploadTargetType = "BulkUploadTargetType",
  SMBProblemDetailsTargetType = "SMBProblemDetailsTargetType",
}
